import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const Clock = (props: Props) => (
  <Svg viewBox='0 0 25 25' fill='none' style={props.style} {...props}>
    <Path
      d='M12.4896 2.08334C6.73962 2.08334 2.08337 6.75 2.08337 12.5C2.08337 18.25 6.73962 22.9167 12.4896 22.9167C18.25 22.9167 22.9167 18.25 22.9167 12.5C22.9167 6.75 18.25 2.08334 12.4896 2.08334ZM12.5 20.8333C7.89587 20.8333 4.16671 17.1042 4.16671 12.5C4.16671 7.89584 7.89587 4.16667 12.5 4.16667C17.1042 4.16667 20.8334 7.89584 20.8334 12.5C20.8334 17.1042 17.1042 20.8333 12.5 20.8333ZM13.0209 7.29167H11.4584V13.5417L16.9271 16.8229L17.7084 15.5417L13.0209 12.7604V7.29167Z'
      fill='#FE5000'
    />
  </Svg>
)
